import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services";

@Component({
  selector: "oauth2-logout",
  template: ``
})
export class OAuth2LogoutComponent implements OnInit{

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {

  }

  ngOnInit(): void {
    this.authenticationService.logout();
    const url = this.route.snapshot.queryParams['returnUrl'];
    window.location.replace(url)
  }
}
